import { render, staticRenderFns } from "./Erp.vue?vue&type=template&id=05c2de53&"
import script from "./Erp.vue?vue&type=script&lang=js&"
export * from "./Erp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports